module.exports = __webpack_public_path__ + "img/bg_function04_1_m.9279813b.gif";